'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _performance_card_data = require('./performance_card_data.js');

var _performance_card_data2 = _interopRequireDefault(_performance_card_data);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropdown_component = require('./global_components/dropdown_component');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _click_or_escape_outside = require('./click_or_escape_outside');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _ramda = require('ramda');

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _calendar_year_performance_returns_chart = require('./charts/calendar_year_performance_returns_chart');

var _calendar_year_performance_returns_chart2 = _interopRequireDefault(_calendar_year_performance_returns_chart);

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _disclosure = require('./disclosure');

var _disclosure2 = _interopRequireDefault(_disclosure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);
var filterNonNullValues = function filterNonNullValues(dataSet) {
  return (0, _ramda.filter)((0, _ramda.complement)(_ramda.isNil), dataSet);
};

var PerformanceCard = function (_React$Component) {
  _inherits(PerformanceCard, _React$Component);

  function PerformanceCard(props) {
    _classCallCheck(this, PerformanceCard);

    var _this = _possibleConstructorReturn(this, (PerformanceCard.__proto__ || Object.getPrototypeOf(PerformanceCard)).call(this, props));

    _this.getLabelForMonths = function (month) {
      switch (month) {
        case "YTD":
          return _string_utility2.default.renderFormattedLabel('YTD', 'label-for-ytd', { role: _this.props.role });
        case "INCEPTION":
          return _string_utility2.default.renderFormattedLabel("SINCE INCEPTION", "pdp-performance-card-since-launch", { role: _this.props.role });
        case "1M":
          return _string_utility2.default.renderFormattedLabel("1 MONTH", "pdp-performance-card-oneMonth", { fundTypeCode: _this.props.fundTypeCode });
        case "3M":
          return _string_utility2.default.renderFormattedLabel("3 MONTHS", "pdp-performance-card-threeMonths", { fundTypeCode: _this.props.fundTypeCode });
        case "6M":
          return _string_utility2.default.renderFormattedLabel("6 MONTHS", "pdp-performance-card-sixMonths", { fundTypeCode: _this.props.fundTypeCode });
        case "1Y":
          return _string_utility2.default.renderFormattedLabel("1 YEAR", "pdp-performance-card-oneYear", { fundTypeCode: _this.props.fundTypeCode });
        case "2Y":
          return _string_utility2.default.renderFormattedLabel("2 YEARS", "pdp-performance-card-twoYears");
        case "3Y":
          return _string_utility2.default.renderFormattedLabel("3 YEARS", "pdp-performance-card-threeYears", { fundTypeCode: _this.props.fundTypeCode });
        case "4Y":
          return _string_utility2.default.renderFormattedLabel("4 YEARS", "pdp-performance-card-fourYears");
        case "5Y":
          return _string_utility2.default.renderFormattedLabel("5 YEARS", "pdp-performance-card-fiveYears", { fundTypeCode: _this.props.fundTypeCode });
        case "10Y":
          return _string_utility2.default.renderFormattedLabel("10 YEARS", "pdp-performance-card-tenYears", { fundTypeCode: _this.props.fundTypeCode });
        case "15Y":
          return _string_utility2.default.renderFormattedLabel("15 YEARS", "pdp-performance-card-fifteenYears", { fundTypeCode: _this.props.fundTypeCode });
        case "3YPA":
          return _string_utility2.default.renderFormattedLabel("3 YEARS (p.a.)", "pdp-performance-card-threeYears-pa", { fundTypeCode: _this.props.fundTypeCode });
        case "5YPA":
          return _string_utility2.default.renderFormattedLabel("5 YEARS (p.a.)", "pdp-performance-card-fiveYears-pa", { fundTypeCode: _this.props.fundTypeCode });
        case "Jan":
          return _string_utility2.default.renderFormattedLabel("Jan", "pdp-performance-card-jan");
        case "Feb":
          return _string_utility2.default.renderFormattedLabel("Feb", "pdp-performance-card-feb");
        case "Mar":
          return _string_utility2.default.renderFormattedLabel("Mar", "pdp-performance-card-mar");
        case "Apr":
          return _string_utility2.default.renderFormattedLabel("Apr", "pdp-performance-card-apr");
        case "May":
          return _string_utility2.default.renderFormattedLabel("May", "pdp-performance-card-may");
        case "Jun":
          return _string_utility2.default.renderFormattedLabel("Jun", "pdp-performance-card-jun");
        case "Jul":
          return _string_utility2.default.renderFormattedLabel("Jul", "pdp-performance-card-jul");
        case "Aug":
          return _string_utility2.default.renderFormattedLabel("Aug", "pdp-performance-card-aug");
        case "Sep":
          return _string_utility2.default.renderFormattedLabel("Sep", "pdp-performance-card-sep");
        case "Oct":
          return _string_utility2.default.renderFormattedLabel("Oct", "pdp-performance-card-oct");
        case "Nov":
          return _string_utility2.default.renderFormattedLabel("Nov", "pdp-performance-card-nov");
        case "Dec":
          return _string_utility2.default.renderFormattedLabel("Dec", "pdp-performance-card-dec");
        default:
          return "";
      }
    };

    _this.getColumnKey = function (month) {
      switch (month) {
        case "YTD":
          return "ytd";
        case "INCEPTION":
          return "inception";
        case "1M":
          return "oneMonth";
        case "3M":
          return "threeMonths";
        case "6M":
          return "sixMonths";
        case "1Y":
          return "oneYear";
        case "2Y":
          return "twoYears";
        case "3Y":
        case "3YPA":
          return "threeYears";
        case "4Y":
          return "fourYears";
        case "5Y":
        case "5YPA":
          return "fiveYears";
        case "10Y":
          return "tenYears";
        case "15Y":
          return "fifteenYears";
        case "Jan":
        case "Feb":
        case "Mar":
        case "Apr":
        case "May":
        case "Jun":
        case "Jul":
        case "Aug":
        case "Sep":
        case "Oct":
        case "Nov":
        case "Dec":
          return month.toLowerCase();
        default:
          return "";
      }
    };

    _this.getColumnLabelDictionary = function (monthArray) {
      var output = {};
      monthArray.forEach(function (month) {
        var key = _this.getColumnKey(month);
        var value = _this.getLabelForMonths(month);
        output[key] = value;
      });
      return output;
    };

    _this.getAsOfDate = function (data) {
      if ((0, _ramda.isNil)(data)) {
        return "";
      }
      var date = "";
      if (!(0, _ramda.isNil)(data.effectiveDate)) {
        date = _date_formatter2.default.getLocalFormattedDate(data.effectiveDate);
      } else if ((0, _ramda.length)(data) > 0 && data[0] && !(0, _ramda.isNil)(data[0].effectiveDate)) {
        date = _date_formatter2.default.getLocalFormattedDate(data[0].effectiveDate);
      }
      return date;
    };

    _this.renderPerformanceData = function (_ref) {
      var data = _ref.data,
          labels = _ref.labels,
          dataTest = _ref.dataTest,
          index = _ref.index,
          key = _ref.key;

      if ((0, _ramda.or)(!_this.isFundPerformanceDataAvailable(data, key) && key !== "AVERAGE_YIELD", key === "AVERAGE_YIELD" && (0, _ramda.isNil)(data) && (0, _ramda.length)(data) < 1)) {
        return null;
      }
      return _react2.default.createElement(_performance_card_data2.default, {
        key: index,
        country: _this.props.country,
        role: _this.props.role,
        printTitle: key,
        data: data,
        labels: labels,
        title: _this.getDataAndLabel()[key].label,
        tableBodyTest: dataTest,
        activeTab: _this.props.activeTab,
        isFlatMode: _this.props.isFlatMode,
        activeReturnType: _this.state.activePerformanceCategory,
        index: index,
        disclosure: _this.props.disclosure,
        largeTextDisclosure: _this.props.largeTextDisclosure,
        currencyCode: _this.props.shareclass.currencyCode,
        visibleDataPoints: _this.props.visibleDataPoints,
        numberFormat: _this.props.numberFormat,
        formattingRules: _this.props.formattingRules,
        breakpoint: _this.props.breakpoint,
        tooltip: _this.props.tooltip,
        tooltipDisclosure: _this.props.tooltipDisclosure
      });
    };

    _this.generateTab = function (dataAndLabel, id, index, firstElement) {
      var data = dataAndLabel.data,
          label = dataAndLabel.label;

      var date = _this.getAsOfDate(data);

      if (!_this.isFundPerformanceDataAvailable(data, id)) {
        return null;
      }
      _this[id + '_tab'] = _react2.default.createRef();
      return _react2.default.createElement(
        'div',
        { id: id,
          key: index,
          'data-index': index,
          role: 'tab',
          ref: _this[id + '_tab'],
          tabIndex: '' + (_this.state.activePerformanceCategory === index ? "0" : "-1"),
          'aria-selected': '' + (_this.state.activePerformanceCategory === index ? "true" : "false"),
          className: 'table-tab ' + (_this.state.activePerformanceCategory === index ? "selected" : "") + ' text-center',
          onClick: function onClick(event) {
            return _this.setActivePerformanceCategory(event, label, id);
          },
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleTabEvents(_this, event, id, id + '_tab', firstElement + '_tab', _this.setActivePerformanceCategory.bind(_this, event, label));
          }
        },
        _react2.default.createElement(
          'span',
          { className: 'sub-header-3', 'data-testid': id + '-tab-name', 'data-index': index },
          label
        ),
        _react2.default.createElement(
          'div',
          { 'data-index': index, 'data-testid': id + '-end-date',
            className: 'as-of-date category' },
          _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of", { role: _this.props.role }),
          date
        )
      );
    };

    _this.renderTabs = function (filteredTabOrder, dataAndLabel) {
      var tabMarkup = (0, _ramda.length)(filteredTabOrder) > 0 ? mapIndexed(function (key, index) {
        return _this.generateTab(dataAndLabel[key], key, index, filteredTabOrder[0]);
      }, filteredTabOrder) : null;

      return _react2.default.createElement(
        'div',
        { className: 'table-tabs-container caption margin-vertical-40 print-hide' },
        _react2.default.createElement(
          'div',
          { className: 'table-tabs', 'data-testid': 'performance-card-tabs', role: 'tablist' },
          tabMarkup
        )
      );
    };

    _this.getColumnLabelsForTableMarkup = function (key) {
      var labels = {};
      switch (key) {
        case "MONTHLY":
          labels = _this.getColumnLabelDictionary(["1M", "3M", "YTD", "1Y", "3Y", "5Y", "10Y", "15Y"]);
          labels["inception"] = _string_utility2.default.renderFormattedLabel("SINCE INCEPTION*", "pdp-performance-card-since-inception", { fundTypeCode: _this.props.fundTypeCode });
          break;
        case "MONTHLY_REIT":
          labels = _this.getColumnLabelDictionary(["1M", "3M", "YTD", "1Y", "3Y", "5Y", "10Y", "15Y"]);
          labels["inception"] = _string_utility2.default.renderFormattedLabel("SINCE INCEPTION*", "pdp-performance-card-since-inception", { fundTypeCode: _this.props.fundTypeCode });
          labels["annualizedDistributionRate"] = _string_utility2.default.renderFormattedLabel("Annualized Distribution Rate", "pdp-performance-card-annualized-dist-rate");
          break;
        case "MONTH_BY_MONTH":
          labels = _this.getColumnLabelDictionary(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "YTD"]);
          break;
        case "QUARTERLY_SMA":
          labels = _this.getColumnLabelDictionary(["3M", "YTD", "1Y", "3Y", "5Y", "10Y"]);
          labels["inception"] = _string_utility2.default.renderFormattedLabel("SINCE INCEPTION*", "pdp-performance-card-since-inception");
          break;
        case "QUARTERLY":
          labels = _this.getColumnLabelDictionary(["1Y", "3Y", "5Y", "10Y", "15Y"]);
          labels["inception"] = _string_utility2.default.renderFormattedLabel("SINCE INCEPTION*", "pdp-performance-card-since-inception");
          break;
        case "CUMULATIVE":
          labels = _this.getColumnLabelDictionary(["1Y", "3Y", "5Y", "10Y", "15Y"]);
          labels["inception"] = _string_utility2.default.renderFormattedLabel("SINCE INCEPTION*", "pdp-performance-card-since-inception", { fundTypeCode: _this.props.fundTypeCode });
          break;
        case "CUMULATIVE_SG":
          labels = _this.getColumnLabelDictionary(["1M", "3M", "1Y", "3Y", "5Y", "INCEPTION"]);
          break;
        case "CUMULATIVE_HK":
          labels = _this.getColumnLabelDictionary(["1M", "1Y", "3Y", "5Y", "INCEPTION"]);
          break;
        case "CUMULATIVE_TW":
          labels = _this.getColumnLabelDictionary(["3M", "6M", "1Y", "2Y", "3Y", "5Y", "YTD", "INCEPTION"]);
          break;
        case "CUMULATIVE_NPSA":
          labels = _this.getColumnLabelDictionary(["1M", "3M", "1Y", "2Y", "3Y", "4Y", "5Y", "INCEPTION"]);
          break;
        case "CUMULATIVE_IT":
          labels = _this.getColumnLabelDictionary(["1Y", "3Y", "5Y"]);
          _this.appendLabelForEmea(labels);
          break;
        case "CUMULATIVE_AIFMD":
          labels = _this.getColumnLabelDictionary(["1M", "3M", "INCEPTION"]);
          break;
        case "CUMULATIVE_EMEA":
          {
            labels = _this.getColumnLabelDictionary(["1M", "3M", "1Y", "3Y", "5Y"]);
            if (_collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, "SHOW_CUMULATIVE_TAB_UP_TO_1YR")) {
              labels = _this.getColumnLabelDictionary(["1M", "3M", "1Y"]);
            } else {
              _this.appendLabelForEmea(labels);
            }
            break;
          }
        case "PERFORMANCE_SUMMARY":
          labels = _this.getColumnLabelDictionary(["1M", "6M", "YTD", "1Y", "3YPA", "5YPA"]);
          break;
        case "YEARLY":
          {
            var yearlyLabels = (0, _ramda.pathOr)([], ["labels"], _this.props.historicalData.historicalCalendarYearPerformanceReturn);
            labels = {
              "oneYear": yearlyLabels[0],
              "twoYears": yearlyLabels[1],
              "threeYears": yearlyLabels[2],
              "fourYears": yearlyLabels[3],
              "fiveYears": yearlyLabels[4],
              "sixYears": yearlyLabels[5],
              "sevenYears": yearlyLabels[6],
              "eightYears": yearlyLabels[7],
              "nineYears": yearlyLabels[8],
              "tenYears": yearlyLabels[9]
            };
            break;
          }
        case "AVERAGE_YIELD":
          {
            var thirtyDayAverageYieldPerformanceReturn = _this.props.historicalData.thirtyDayAverageYieldPerformanceReturn;

            if (!(0, _ramda.isNil)(thirtyDayAverageYieldPerformanceReturn)) {
              var counter = 0;
              for (var i = (0, _ramda.length)(thirtyDayAverageYieldPerformanceReturn); i > 0; --i) {
                labels[counter] = thirtyDayAverageYieldPerformanceReturn[i - 1].label;
                counter++;
              }
            }
            break;
          }
        case "CALENDAR_YEAR":
          {
            var calendarYearLabels = (0, _ramda.pathOr)([], ["labels"], _this.props.historicalData.historicalCalendarYearPerformanceReturn);

            labels = {
              "fiveYears": calendarYearLabels[0],
              "sixYears": calendarYearLabels[1],
              "sevenYears": calendarYearLabels[2],
              "eightYears": calendarYearLabels[3],
              "nineYears": calendarYearLabels[4],
              "tenYears": _string_utility2.default.renderFormattedLabel(calendarYearLabels[5], "pdp-performance-card-tab-calendar-year-year10", calendarYearLabels[5])
            };

            if ((0, _ramda.or)((0, _ramda.and)(_this.props.country === 'au', _this.props.role !== 'liq'), (0, _ramda.and)(_this.props.country === 'sg', _this.props.role !== 'liq'))) {
              delete labels["fiveYears"];
            }
            break;
          }
        case "CALENDAR_YEAR_NPSA":
        case "CALENDAR_YEAR_EMEA":
          {
            var calendarYearEmeaLabels = (0, _ramda.pathOr)([], ["labels"], _this.props.historicalData.historicalCalendarYearPerformanceReturn);
            labels = {
              "oneYear": calendarYearEmeaLabels[0],
              "twoYears": calendarYearEmeaLabels[1],
              "threeYears": calendarYearEmeaLabels[2],
              "fourYears": calendarYearEmeaLabels[3],
              "fiveYears": calendarYearEmeaLabels[4],
              "sixYears": calendarYearEmeaLabels[5],
              "sevenYears": calendarYearEmeaLabels[6],
              "eightYears": calendarYearEmeaLabels[7],
              "nineYears": calendarYearEmeaLabels[8],
              "tenYears": calendarYearEmeaLabels[9],
              "ytd": _this.getLabelForMonths("YTD")
            };
            break;
          }
        case "ANNUALIZED":
          {
            var annualizedPerformanceReturns = _this.props.shareclass.annualizedPerformanceReturns;

            labels = _this.getColumnLabelDictionary(["3Y", "5Y"]);

            if (annualizedPerformanceReturns && annualizedPerformanceReturns[0].tenYears) {
              labels.tenYears = _this.getLabelForMonths("10Y");
            } else {
              labels.inception = _this.getLabelForMonths("INCEPTION");
            }

            if ((0, _ramda.and)(_this.props.country === 'au', _this.props.role !== 'liq')) {
              labels = _this.getColumnLabelDictionary(["1Y", "3Y", "5Y", "INCEPTION"]);
            }
            break;
          }
        case "ANNUALIZED_SG":
          labels = _this.getColumnLabelDictionary(["3Y", "5Y", "INCEPTION"]);
          break;
        case "ANNUALIZED_NPSA":
          labels = _this.getColumnLabelDictionary(["2Y", "3Y", "4Y", "5Y", "INCEPTION"]);
          break;
        case "QUARTERLY_ROLLING":
          labels = _this.props.shareclass.quarterlyRollingPerformanceReturns.headers;
          break;
        case "MONTHLY_ROLLING":
          labels = _this.props.shareclass.monthlyRollingPerformanceReturns.headers;
          break;
        default:
          break;
      }
      return labels;
    };

    _this.getTableMarkup = function (key, index) {
      var data = void 0,
          dataTest = void 0;
      var labels = _this.getColumnLabelsForTableMarkup(key);
      switch (key) {
        case "MONTHLY":
          data = _this.props.shareclass.performanceReturns;
          dataTest = "monthly-performance-data";
          break;
        case "MONTHLY_REIT":
          data = _this.props.shareclass.performanceReturns;
          dataTest = "monthly-performance-data";
          break;
        case "MONTH_BY_MONTH":
          data = _this.props.historicalData.monthByMonthPerformanceReturns;
          dataTest = "month-by-month-performance-data";
          break;
        case "QUARTERLY":
        case "QUARTERLY_SMA":
          data = _this.props.historicalData.quarterlyPerformanceReturns;
          dataTest = "quarterly-performance-data";
          break;
        case "CUMULATIVE":
        case "CUMULATIVE_SG":
        case "CUMULATIVE_HK":
        case "CUMULATIVE_TW":
        case "CUMULATIVE_NPSA":
        case "CUMULATIVE_IT":
        case "CUMULATIVE_EMEA":
        case "CUMULATIVE_AIFMD":
          data = _this.props.shareclass.cumulativePerformanceReturns;
          dataTest = "cumulative-performance-data";
          break;
        case "PERFORMANCE_SUMMARY":
          data = _this.props.shareclass.performanceSummaryReturns;
          dataTest = "performance-summary-data";
          break;
        case "YEARLY":
          data = (0, _ramda.pathOr)([], ["performanceData"], _this.props.historicalData.historicalCalendarYearPerformanceReturn);
          dataTest = "yearly-performance-data";
          break;
        case "AVERAGE_YIELD":
          {
            var thirtyDayAverageYieldPerformanceReturn = _this.props.historicalData.thirtyDayAverageYieldPerformanceReturn;

            var performanceData = {};
            if (!(0, _ramda.isNil)(thirtyDayAverageYieldPerformanceReturn)) {
              var counter = 0;
              for (var i = (0, _ramda.length)(thirtyDayAverageYieldPerformanceReturn); i > 0; --i) {
                performanceData[counter] = thirtyDayAverageYieldPerformanceReturn[i - 1].value;
                counter++;
              }
            }
            data = [performanceData];
            break;
          }
        case "CALENDAR_YEAR_NPSA":
        case "CALENDAR_YEAR":
          data = (0, _ramda.pathOr)([], ["performanceData"], _this.props.historicalData.historicalCalendarYearPerformanceReturn);
          dataTest = "calendar-year-performance-data";
          break;
        case "CALENDAR_YEAR_EMEA":
          if (!(0, _functional_utility.isNilOrEmpty)(_this.props.visibleCharts) && _collection_utility.CollectionUtility.includes(_this.props.visibleCharts, 'CAL_YEAR_PERF_CHART')) {
            return _this.renderCalYearChart();
          }
          data = (0, _ramda.pathOr)([], ["performanceData"], _this.props.historicalData.historicalCalendarYearPerformanceReturn);
          dataTest = "calendar-year-performance-data";
          break;
        case "ANNUALIZED":
        case "ANNUALIZED_SG":
        case "ANNUALIZED_NPSA":
          data = _this.props.shareclass.annualizedPerformanceReturns;
          dataTest = "annualized-performance-data";
          break;
        case "QUARTERLY_ROLLING":
          data = _this.props.shareclass.quarterlyRollingPerformanceReturns;
          dataTest = "quarterly-rolling-performance-data";
          break;
        case "MONTHLY_ROLLING":
          data = _this.props.shareclass.monthlyRollingPerformanceReturns;
          dataTest = "monthly-rolling-performance-data";
          break;
        default:
          break;
      }

      return _this.renderPerformanceData({
        data: data,
        labels: labels,
        dataTest: dataTest,
        index: index,
        key: key
      });
    };

    _this.getCalendarYearPerformanceTableMarkupForEMEA = function (key, index) {
      var historicalCalendarYearPerformanceReturn = _this.props.historicalData.historicalCalendarYearPerformanceReturn;

      var labels = (0, _ramda.pathOr)([], ["labels"], historicalCalendarYearPerformanceReturn);
      var modifiedLabel = {
        "sixYears": labels[0],
        "sevenYears": labels[1],
        "eightYears": labels[2],
        "nineYears": labels[3],
        "tenYears": labels[4],
        "ytd": _this.getLabelForMonths("YTD")
      };
      return _this.renderPerformanceData({
        data: (0, _ramda.pathOr)([], ["performanceData"], historicalCalendarYearPerformanceReturn),
        labels: modifiedLabel,
        dataTest: "calendar-year-performance-data",
        index: index,
        key: key
      });
    };

    _this.renderTable = function (filteredTabOrder) {
      var markup = mapIndexed(function (key, index) {
        return _this.getTableMarkup(key, index);
      }, filteredTabOrder);
      return filterNonNullValues(markup);
    };

    _this.addForMobileSuffix = function (str) {
      var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-for-mobile-bp";

      var isDropdownDisplay = _this.props.breakpoint < 4;
      return '' + str + (isDropdownDisplay ? suffix : "");
    };

    _this.getCumulativeReturnObject = function (label1, key1) {
      var role = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var label2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var key2 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var isDropdownDisplay = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

      return {
        data: _this.props.shareclass.cumulativePerformanceReturns,
        "label": _this.getPerformanceReturnLabel(isDropdownDisplay, label1, key1, label2, key2, role)
      };
    };

    _this.getAnnualizedReturnObject = function (isDropdownDisplay) {
      return {
        data: _this.props.shareclass.annualizedPerformanceReturns,
        "label": _this.getPerformanceReturnLabel(isDropdownDisplay, "Annualised as of ", "pdp-performance-card-tab-annualised-as-of-label-for-mobile-bp", "Annualised", "pdp-performance-card-tab-annualised-label", _this.props.role)
      };
    };

    _this.getCalendarYearReturnObject = function () {
      return {
        data: (0, _functional_utility.pathOrNull)(["performanceData"], _this.props.historicalData.historicalCalendarYearPerformanceReturn),
        "label": _string_utility2.default.renderFormattedLabel("Calendar Year", _this.addForMobileSuffix("pdp-performance-card-tab-calendar-year-as-of-label"), { role: _this.props.role })
      };
    };

    _this.getPerformanceSummaryReturnObject = function () {
      return {
        data: _this.props.shareclass.performanceSummaryReturns,
        "label": _string_utility2.default.renderFormattedLabel("Performance Summary (%)", _this.addForMobileSuffix("pdp-performance-card-tab-performance-summary-year-as-of-label"))
      };
    };

    _this.getPerformanceReturnLabel = function (isDropdownDisplay, defaultLabel1, translatedKey1, defaultLabel2, translatedKey2) {
      var role = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var fundTypeCode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

      return isDropdownDisplay ? _string_utility2.default.renderFormattedLabel(defaultLabel1, translatedKey1, { role: role }) : _string_utility2.default.renderFormattedLabel(defaultLabel2, translatedKey2, { role: role, fundTypeCode: fundTypeCode });
    };

    _this.state = {
      activePerformanceCategory: 0,
      activePerCatId: 'MONTHLY'
    };
    return _this;
  }

  _createClass(PerformanceCard, [{
    key: 'focusItemForReference',
    value: function focusItemForReference(refString) {
      this[refString].current.focus();
    }
  }, {
    key: 'focusNextItem',
    value: function focusNextItem(refString) {
      this[refString].current.nextElementSibling.focus();
    }
  }, {
    key: 'focusPreviousItem',
    value: function focusPreviousItem(refString) {
      this[refString].current.previousElementSibling.focus();
    }
  }, {
    key: 'isFundPerformanceDataAvailable',
    value: function isFundPerformanceDataAvailable(data, key) {
      var isDataAvailable = false;
      if ((0, _ramda.isNil)(data) || (0, _ramda.length)(data) < 1) {
        isDataAvailable = false;
      }
      if (!(0, _ramda.isNil)(data.effectiveDate) || (0, _ramda.length)(data) > 0 && data[0].effectiveDate) {
        isDataAvailable = true;
      }

      var allNull = true;
      var labelArr = this.getColumnLabelsForTableMarkup(key);

      if (isDataAvailable && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "IS_NOT_ALLOW_REQUIRED_DATA_NULLABLE") && labelArr != null) {
        var labelNameArr = Object.keys(labelArr);
        _collection_utility.CollectionUtility.forEachIndexed(labelNameArr, function (item) {
          _collection_utility.CollectionUtility.forEachIndexed(data, function (row) {
            if (row[item] != null) {
              allNull = false;
            }
          });
        });

        isDataAvailable = allNull ? false : true;
      }

      return isDataAvailable;
    }
  }, {
    key: 'setActivePerformanceCategory',
    value: function setActivePerformanceCategory(event, label, id) {
      var activeReturnType = event.target.getAttribute("data-index");

      if (event.target.className === "dropdown-list-item") {
        activeReturnType = event.target.querySelector("span").getAttribute("data-index");
      } else if (!activeReturnType) {
        activeReturnType = event.target.parentNode.getAttribute("data-index");
      }

      var trackingLabel = (typeof label === 'undefined' ? 'undefined' : _typeof(label)) == "object" ? label.props.defaultMessage : label;
      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": (0, _functional_utility.isNilOrEmpty)(this.props.appType) ? 'other' : _tracking_utility.TrackingUtility.getEventCategory(this.props.appType),
        "eventAction": 'performance card',
        "eventLabel": (0, _functional_utility.isNilOrEmpty)(trackingLabel) ? trackingLabel : trackingLabel.replace(' as of', '').trim()
      });

      this.setState({ activePerformanceCategory: parseInt(activeReturnType, 10), activePerCatId: id });
    }
  }, {
    key: 'renderDropdown',
    value: function renderDropdown(filteredTabOrder, dropdownData) {
      return _react2.default.createElement(
        'div',
        { className: 'table-tabs-container margin-vertical-20 print-hide' },
        _react2.default.createElement(
          'div',
          { 'data-testid': 'return-type',
            className: 'tag-2 margin-bottom-10' },
          _string_utility2.default.renderFormattedLabel("Return Type", "pdp-performance-card-return-type-label")
        ),
        _react2.default.createElement(
          _click_or_escape_outside2.default,
          { id: 'performance-card-selector-click-or-escape-outside' },
          _react2.default.createElement(_dropdown_component2.default, {
            dropdownContent: this.dropdownContent(dropdownData, filteredTabOrder),
            className: 'table-dropdown',
            id: 'performance-card-selector',
            breakpoint: this.props.breakpoint,
            initialActiveSelect: _react2.default.createElement(
              'div',
              null,
              dropdownData[filteredTabOrder[this.state.activePerformanceCategory]].label,
              this.getAsOfDate(dropdownData[filteredTabOrder[this.state.activePerformanceCategory]].data)
            ),
            alwaysOpenOnSelect: false
          })
        )
      );
    }
  }, {
    key: 'dropdownContent',
    value: function dropdownContent(dropdownData, filteredTabOrder) {
      var _this2 = this;

      if ((0, _ramda.isNil)(filteredTabOrder)) {
        return null;
      }
      var lastIndex = filteredTabOrder.length - 1;
      var dropdownMarkup = mapIndexed(function (key, index) {
        if (!_this2.isFundPerformanceDataAvailable(dropdownData[key].data, key) || index === _this2.state.activePerformanceCategory) {
          return null;
        }
        _this2[index + 'performanceDropDown'] = _react2.default.createRef();
        var isLastElement = lastIndex === index;
        return _react2.default.createElement(
          'div',
          {
            tabIndex: '0',
            key: key,
            ref: _this2[index + 'performanceDropDown'],
            className: 'dropdown-list-item',
            'data-testid': 'dropdown-on-change',
            'data-index': index,
            role: 'option',
            onClick: function onClick(event) {
              return _this2.setActivePerformanceCategory(event, dropdownData[key].label);
            },
            onKeyDown: function onKeyDown(event) {
              return _accessibility_utility2.default.handleDropdownEvents(_this2, event, '#performance-card-selector', index + 'performanceDropDown', '1performanceDropDown', isLastElement, _this2.setActivePerformanceCategory.bind(_this2, event, dropdownData[key].label));
            }
          },
          _react2.default.createElement(
            'span',
            { className: 'body2',
              'data-index': index },
            dropdownData[key].label,
            _this2.getAsOfDate(dropdownData[key].data)
          )
        );
      }, filteredTabOrder);

      return filterNonNullValues(dropdownMarkup);
    }
  }, {
    key: 'renderCalYearChart',
    value: function renderCalYearChart() {
      var historicalCalendarYearPerformanceReturn = this.props.historicalData.historicalCalendarYearPerformanceReturn;

      if ((0, _functional_utility.isNilOrEmpty)(historicalCalendarYearPerformanceReturn) || (0, _functional_utility.isNilOrEmpty)(historicalCalendarYearPerformanceReturn.performanceData)) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        {
          className: '' + (this.state.activePerformanceCategory === 0 ? 'display-block print-display' : 'display-none print-display') },
        _react2.default.createElement(
          'div',
          { className: 'font-black-variant tag text-left font-regular padding-left-8',
            'data-testid': 'cal-year-perf-chart-title' },
          _string_utility2.default.renderFormattedLabel("Calendar year performance % as of ", 'pdp-performance-card-tab-calendar-year-as-of-label-for-mobile-bp'),
          this.getAsOfDate(historicalCalendarYearPerformanceReturn.performanceData)
        ),
        _react2.default.createElement(_calendar_year_performance_returns_chart2.default, { historicalCalendarYearPerformanceReturn: historicalCalendarYearPerformanceReturn,
          visibleDataPoints: this.props.visibleDataPoints,
          shareclassName: this.props.shareclass.name, numberFormat: this.props.numberFormat,
          fiveYear: false, hoverState: false
        })
      );
    }
  }, {
    key: 'appendLabelForEmea',
    value: function appendLabelForEmea(labels) {
      var cumulativePerformanceReturns = this.props.shareclass.cumulativePerformanceReturns;

      if (cumulativePerformanceReturns && !(0, _ramda.isEmpty)(cumulativePerformanceReturns) && cumulativePerformanceReturns[0].tenYears) {
        labels.tenYears = this.getLabelForMonths("10Y");
      } else {
        labels.inception = this.getLabelForMonths("INCEPTION");
      }
    }
  }, {
    key: 'getDataAndLabel',
    value: function getDataAndLabel() {
      var _props$shareclass = this.props.shareclass,
          performanceReturns = _props$shareclass.performanceReturns,
          quarterlyRollingPerformanceReturns = _props$shareclass.quarterlyRollingPerformanceReturns,
          monthlyRollingPerformanceReturns = _props$shareclass.monthlyRollingPerformanceReturns;
      var _props$historicalData = this.props.historicalData,
          quarterlyPerformanceReturns = _props$historicalData.quarterlyPerformanceReturns,
          thirtyDayAverageYieldPerformanceReturn = _props$historicalData.thirtyDayAverageYieldPerformanceReturn,
          historicalCalendarYearPerformanceReturn = _props$historicalData.historicalCalendarYearPerformanceReturn,
          monthByMonthPerformanceReturns = _props$historicalData.monthByMonthPerformanceReturns;

      var isDropdownDisplay = this.props.breakpoint < 4 || !(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)('FLAT_MODE', this.props.visibleDataPoints);

      return {
        "QUARTERLY_ROLLING": {
          data: quarterlyRollingPerformanceReturns,
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Quarterly rolling 12 months as of ", "pdp-performance-card-tab-quarterly-rolling-as-of-label-for-mobile-bp", "Quarterly rolling 12 months", "pdp-performance-card-tab-quarterly-rolling-label")
        },
        "QUARTERLY": {
          data: quarterlyPerformanceReturns,
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Quarterly as of ", "pdp-performance-card-tab-quarterly-as-of-label-for-mobile-bp", "Quarterly", "pdp-performance-card-tab-quarterly-label")
        },
        "QUARTERLY_SMA": {
          data: quarterlyPerformanceReturns,
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Quarterly as of ", "pdp-performance-card-tab-quarterly-as-of-label-for-mobile-bp", "Quarterly", "pdp-performance-card-tab-quarterly-label")
        },
        "MONTHLY": {
          data: performanceReturns,
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Monthly as of ", "pdp-performance-card-tab-monthly-as-of-label-for-mobile-bp", "Monthly", "pdp-performance-card-tab-monthly-label", null, this.props.fundTypeCode)
        },
        "MONTHLY_REIT": {
          data: performanceReturns,
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Monthly as of ", "pdp-performance-card-tab-monthly-as-of-label-for-mobile-bp", "Monthly", "pdp-performance-card-tab-monthly-label", null, this.props.fundTypeCode)
        },
        "MONTH_BY_MONTH": {
          data: monthByMonthPerformanceReturns,
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Month by Month as of ", "pdp-performance-card-tab-monthly-as-of-label-for-mobile-bp", "Month by Month", "pdp-performance-card-tab-month-by-month-label")
        },
        "MONTHLY_ROLLING": {
          data: monthlyRollingPerformanceReturns,
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Monthly rolling 12 months as of ", "pdp-performance-card-tab-monthly-rolling-as-of-label-for-mobile-bp", "Monthly rolling 12 months", "pdp-performance-card-tab-monthly-rolling-label")
        },
        "YEARLY": {
          data: (0, _functional_utility.pathOrNull)(["performanceData"], historicalCalendarYearPerformanceReturn),
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Calendar as of ", "pdp-performance-card-tab-yearly-as-of-label-for-mobile-bp", "Calendar Year", "pdp-performance-card-tab-yearly-label")
        },
        "CUMULATIVE": this.getCumulativeReturnObject("Cumulative as of ", null, this.props.role, "Cumulative", "pdp-performance-card-tab-cumulative-label", isDropdownDisplay),
        "CUMULATIVE_EMEA": this.getCumulativeReturnObject('Cumulative as of ', 'pdp-performance-card-tab-cumulative-as-of-label-for-mobile-bp', this.props.role, 'Cumulative', 'pdp-performance-card-tab-cumulative-label', isDropdownDisplay),
        "CUMULATIVE_AIFMD": this.getCumulativeReturnObject('Cumulative as of ', 'pdp-performance-card-tab-cumulative-as-of-label-for-mobile-bp', this.props.role, 'Cumulative', 'pdp-performance-card-tab-cumulative-label', isDropdownDisplay),
        "CUMULATIVE_IT": this.getCumulativeReturnObject('Cumulative as of ', 'pdp-performance-card-tab-cumulative-as-of-label-for-mobile-bp', this.props.role, 'Cumulative', 'pdp-performance-card-tab-cumulative-label', isDropdownDisplay),
        "CUMULATIVE_SG": this.getCumulativeReturnObject("Cumulative (%) as of ", "pdp-performance-card-tab-cumulative-as-of-label-for-mobile-bp", null, "Cumulative", "pdp-performance-card-tab-cumulative-label", isDropdownDisplay),
        "CUMULATIVE_HK": this.getCumulativeReturnObject("Cumulative (%) as of ", "pdp-performance-card-tab-cumulative-as-of-label-for-mobile-bp", null, "Cumulative", "pdp-performance-card-tab-cumulative-label", isDropdownDisplay),
        "CUMULATIVE_TW": this.getCumulativeReturnObject("Cumulative (%) as of ", "pdp-performance-card-tab-cumulative-as-of-label-for-mobile-bp", null, "Cumulative", "pdp-performance-card-tab-cumulative-label", isDropdownDisplay),
        "CUMULATIVE_NPSA": this.getCumulativeReturnObject("Cumulative (%) as of ", "pdp-performance-card-tab-cumulative-as-of-label-for-mobile-bp", null, "Cumulative", "pdp-performance-card-tab-cumulative-label", isDropdownDisplay),
        "AVERAGE_YIELD": {
          data: thirtyDayAverageYieldPerformanceReturn,
          "label": this.getPerformanceReturnLabel(isDropdownDisplay, "Thirty day current yield as of ", 'pdp-performance-card-tab-thirty-day-avg-yield-as-of-label-for-mobile-bp', "Thirty day current yield", 'pdp-performance-card-tab-thirty-day-avg-yield')
        },
        "ANNUALIZED": this.getAnnualizedReturnObject(isDropdownDisplay),
        "ANNUALIZED_SG": this.getAnnualizedReturnObject(isDropdownDisplay),
        "ANNUALIZED_NPSA": this.getAnnualizedReturnObject(isDropdownDisplay),
        "CALENDAR_YEAR": this.getCalendarYearReturnObject(),
        "CALENDAR_YEAR_EMEA": this.getCalendarYearReturnObject(),
        "CALENDAR_YEAR_NPSA": this.getCalendarYearReturnObject(),
        "PERFORMANCE_SUMMARY": this.getPerformanceSummaryReturnObject(),
        // TODO: will be creating a 10 year calendar year bar chart but data will be sourced from a different location in GFR - similar to be/en. Chart logic will have new requirements
        "TEN_YEAR_CALENDAR_YEAR_BAR_CHART": {
          data: [],
          "label": ""
        }
      };
    }
  }, {
    key: 'renderNonArticle6Disclosure',
    value: function renderNonArticle6Disclosure() {
      if (!_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "PERFORMANCE_CARD_NON_ARTICLE6_DISCLOSURE") && !_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "PERFORMANCE_CARD_ARTICLE9_DISCLOSURE")) {
        return null;
      }

      var disclosure = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "PERFORMANCE_CARD_ARTICLE9_DISCLOSURE") ? 'performance-card-article9-disclosure' : 'performance-card-non-article6-disclosure';

      return _react2.default.createElement(
        'div',
        { className: 'padding-top-20', 'data-testid': 'nonArticle6-disclosure' },
        _react2.default.createElement(
          'span',
          { className: 'font-light font-16 padding-top-10',
            'data-testid': 'nonArticle6-disclosure-text' },
          _string_utility2.default.renderFormattedLabel('', disclosure)
        )
      );
    }
  }, {
    key: 'renderBenchmarkTickerCodes',
    value: function renderBenchmarkTickerCodes() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.benchmarkTickerCodes) || (0, _ramda.indexOf)("SHOW_BENCHMARK_TICKER_CODES", this.props.visibleDataPoints) === -1) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'padding-top-20', 'data-testid': 'benchmark-ticker-codes' },
        _react2.default.createElement(
          'span',
          { className: 'title font-normal tag',
            'data-testid': 'benchmark-ticker-codes-heading' },
          _string_utility2.default.renderFormattedLabel('Benchmark ticker:', 'Benchmark ticker')
        ),
        '\xA0',
        _react2.default.createElement(
          'span',
          { className: 'font-light font-16 padding-top-10',
            'data-testid': 'benchmark-ticker-codes-text' },
          (0, _ramda.join)("/", this.props.benchmarkTickerCodes)
        )
      );
    }
  }, {
    key: 'renderBenchmarkNames',
    value: function renderBenchmarkNames() {
      if (!(0, _ramda.isNil)(this.props.benchmarkNames) && (0, _ramda.length)(this.props.benchmarkNames) > 0 && (0, _ramda.indexOf)("BENCHMARK_NAMES", this.props.visibleRegionalData) > -1) {
        return _react2.default.createElement(
          'div',
          { className: 'padding-top-20', 'data-testid': 'benchmark-names' },
          _react2.default.createElement(
            'span',
            { className: 'title font-normal tag',
              'data-testid': 'benchmark-names-heading' },
            _string_utility2.default.renderFormattedLabel('Benchmark', 'Benchmark')
          ),
          _react2.default.createElement(
            'div',
            { className: 'font-light font-16 padding-top-10', 'data-testid': 'benchmark-names-text' },
            (0, _ramda.join)("/", this.props.benchmarkNames)
          )
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'renderToggle',
    value: function renderToggle() {
      var _this3 = this;

      var containerClass = (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) ? "display-inline-flex padding-top-22 width-percent-100" : "display-inline float-right padding-top-5";
      var toggleClass = (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) ? "freq-toggle text-center vertical-align-middle width-percent-50" : "freq-toggle";
      var inactiveTypography = (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) ? " body2" : " disclaimer";
      var activeTypography = (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) ? " body2" : " disclaimer2";

      return _react2.default.createElement(
        'div',
        { className: containerClass },
        _react2.default.createElement(
          'span',
          { id: 'month-end-returns', className: toggleClass + activeTypography, style: { cursor: 'auto', color: 'black', padding: '8px', background: 'white', border: '1px solid #E2E4E5' } },
          _string_utility2.default.renderFormattedLabel("Month-end Returns", "pdp-performance-month-end-return-toggle-label")
        ),
        _react2.default.createElement(
          'span',
          { id: 'daily-returns', className: toggleClass + inactiveTypography, onClick: function onClick() {
              return _this3.props.togglePerformanceCard('dailyReturns');
            }, style: { cursor: 'pointer', color: '#096183', padding: '8px', background: '#F5F7F8', border: '1px solid #E2E4E5' } },
          _string_utility2.default.renderFormattedLabel("Daily Returns", "pdp-performance-daily-return-toggle-label")
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "PERFORMANCE_CARD_SHOULD_WARN_EMPTY_PERFORMANCE_RETURN") && ((0, _ramda.isNil)(this.props.shareclass.performanceReturns) || !this.props.shareclass.renderPerformanceCard)) {
        return null;
      }

      var tabOrder = this.props.tabOrder;

      var dataAndLabel = this.getDataAndLabel();
      var headerClass = this.props.showToggleView ? " display-inline" : "";

      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHOW_BENCHMARK_NAMES") && (0, _ramda.isNil)(this.props.shareclass.performanceReturns) && !this.props.isShareClassMoreThanAnYearOld && !_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "SHOW_PERFORMANCE_LESS_THAN_AN_YEAR_OLD")) {
        var pdpCardPerformanceUnder1Year = (0, _functional_utility.pathOrNull)(["tooltipDisclosure", "pdpCardPerformanceUnder1Year"], this.props);
        return _react2.default.createElement(
          'div',
          { id: 'performance' },
          _react2.default.createElement(
            'div',
            { 'data-testid': 'performance-data', className: 'padding-left-0 padding-right-0' },
            _react2.default.createElement(
              'div',
              {
                className: 'background-white border-radius-3 table-shadow margin-vertical-16 padding-top-16 padding-bottom-5 margin-bottom-16 padding-horizontal-30' },
              _react2.default.createElement(
                'div',
                { className: 'card-header border-bottom-2 border-light-grey padding-bottom-20 print-hide',
                  'data-testid': 'performance-tabs' },
                _react2.default.createElement(
                  'h2',
                  { id: 'performance-card-header-label', 'data-testid': 'performance-card-header-label',
                    className: 'font-regular font-black-variant sub-header-3 print-hide' + headerClass },
                  _string_utility2.default.renderFormattedLabel("Performance", "pdp-performance-card-label")
                ),
                this.props.showToggleView && !(0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) && this.renderToggle()
              ),
              this.props.showToggleView && (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) && this.renderToggle(),
              this.renderBenchmarkNames(),
              this.renderBenchmarkTickerCodes(),
              this.renderNonArticle6Disclosure(),
              pdpCardPerformanceUnder1Year && _react2.default.createElement(_disclosure2.default, {
                disclosureText: pdpCardPerformanceUnder1Year,
                placementId: 'pdpCardPerformanceUnder1Year',
                shouldAlwaysShowMore: true
              }),
              _react2.default.createElement('br', null)
            )
          )
        );
      }

      var filteredTabOrder = _collection_utility.CollectionUtility.filter(tabOrder, function (key, index) {
        if (!(0, _ramda.isEmpty)(_this4.getAsOfDate(dataAndLabel[key].data))) {
          return tabOrder[index];
        }
      });

      var returnTypeTabs = null,
          table = null,
          subTitle1 = null,
          subTitle2 = null;
      var hidePerformanceData = !(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)('HIDE_PERFORMANCE_DATA', this.props.visibleDataPoints);

      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'PERFORMANCE_CARD_SHOULD_WARN_ABOUT_YOUNG_FUND') && !this.props.isShareclassMoreThanSixMonthsOld) {
        returnTypeTabs = _react2.default.createElement('br', null);
        table = _react2.default.createElement(
          'h3',
          { 'data-testid': 'performance-card-six-months-label',
            id: 'performance-card-six-months-label',
            className: 'font-regular font-black-variant sub-header-3 print-hide' },
          _string_utility2.default.renderFormattedLabel("Performance data will be published for funds with a track record of over six months.", "pdp-performance-card-display-after-six-month-label")
        );
      } else if (_collection_utility.CollectionUtility.includes(this.props.formattingRules, 'PERFORMANCE_DATA_LESS_THAN_1YR')) {
        returnTypeTabs = _react2.default.createElement('br', null);
        table = _react2.default.createElement(
          'h3',
          { 'data-testid': 'performance-card-disclosure-less-than-1yr',
            id: 'performance-card-disclosure-less-than-1yr',
            className: 'font-regular font-black-variant sub-header-4 print-hide' },
          _string_utility2.default.renderFormattedLabel("In accordance with National Instrument 81-102, performance cannot be shown until one year after the inception of a fund or series.", "pdp-performance-card-display-after-one-year-label")
        );
      } else if (tabOrder.includes('TEN_YEAR_CALENDAR_YEAR_BAR_CHART')) {
        return _react2.default.createElement(
          'div',
          { id: 'performance' },
          _react2.default.createElement(
            'div',
            { 'data-testid': 'performance-data', className: 'padding-left-0 padding-right-0' },
            _react2.default.createElement(
              'div',
              {
                className: 'background-white pdp-tab-card-container ' + (this.props.breakpoint < 3 ? "padding-horizontal-15 margin-bottom-16" : "padding-horizontal-30 margin-bottom-32") },
              _react2.default.createElement(
                'div',
                { className: 'print-hide padding-bottom-20 margin-horizontal--30 padding-horizontal-30 padding-top-10 border-bottom-1 border-card-title-border',
                  'data-testid': 'performance-tabs' },
                _react2.default.createElement(
                  'h2',
                  { id: 'performance-card-header-label', 'data-testid': 'performance-card-header-label',
                    className: 'sub-header-' + (this.props.breakpoint < 3 ? '3' : '2') + ' print-hide' + headerClass },
                  _string_utility2.default.renderFormattedLabel("Performance", "pdp-performance-card-label")
                )
              )
            )
          )
        );
      } else if (!hidePerformanceData) {
        if ((0, _ramda.length)(filteredTabOrder) < 1) {
          return null;
        }

        if (!this.props.isFlatMode || this.props.breakpoint <= 3) {
          returnTypeTabs = this.props.breakpoint > 3 ? this.renderTabs(filteredTabOrder, dataAndLabel) : this.renderDropdown(filteredTabOrder, dataAndLabel);
        }
        table = this.renderTable(filteredTabOrder);
        subTitle1 = _react2.default.createElement(
          'span',
          { 'data-testid': 'performance-card-subtitle-1',
            className: 'font-light disclaimer display-block' },
          _string_utility2.default.renderFormattedLabel(" ", "pdp-performance-card-subtitle-1", {
            "currencyCode": _currency_utility2.default.getCurrencyTranslation(this.props.shareclass.currencyCode)
          })
        );
        subTitle2 = _react2.default.createElement(
          'span',
          { 'data-testid': 'performance-card-subtitle-2',
            className: 'font-light disclaimer display-block' },
          _string_utility2.default.renderFormattedLabel(" ", "pdp-performance-card-subtitle-2", {
            "launchDate": _date_formatter2.default.getLocalFormattedDate(this.props.shareclass.shareClassInceptionDate),
            role: this.props.role
          })
        );
      }
      return _react2.default.createElement(
        'div',
        { id: 'performance' },
        _react2.default.createElement(
          'div',
          { 'data-testid': 'performance-data', className: 'padding-left-0 padding-right-0' },
          _react2.default.createElement(
            'div',
            {
              className: 'background-white pdp-tab-card-container ' + (this.props.breakpoint < 3 ? "padding-horizontal-15 margin-bottom-16" : "padding-horizontal-30 margin-bottom-32") },
            _react2.default.createElement(
              'div',
              { className: 'print-hide padding-bottom-20 margin-horizontal--30 padding-horizontal-30 padding-top-10 border-bottom-1 border-card-title-border',
                'data-testid': 'performance-tabs' },
              _react2.default.createElement(
                'h2',
                { id: 'performance-card-header-label', 'data-testid': 'performance-card-header-label',
                  className: 'sub-header-' + (this.props.breakpoint < 3 ? '3' : '2') + ' print-hide' + headerClass },
                _string_utility2.default.renderFormattedLabel("Performance", "pdp-performance-card-label")
              ),
              this.props.showToggleView && !(0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) && this.renderToggle(),
              subTitle1,
              subTitle2
            ),
            this.props.showToggleView && (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint) && this.renderToggle(),
            this.renderBenchmarkNames(),
            this.renderBenchmarkTickerCodes(),
            this.renderNonArticle6Disclosure(),
            !returnTypeTabs && _react2.default.createElement('br', null),
            returnTypeTabs,
            _react2.default.createElement(
              'div',
              { role: "tabpanel", tabIndex: "0", 'aria-describedby': this.state.activePerCatId },
              table,
              !hidePerformanceData && _react2.default.createElement(
                'div',
                { 'data-testid': 'pdpCardPerformance',
                  className: 'disclosure display-inline-block font-light disclaimer font-slate-grey margin-top-20',
                  style: { width: "100%" } },
                !(0, _ramda.isNil)(this.props.largeTextDisclosure) && _react2.default.createElement(
                  'div',
                  {
                    className: 'caption display-inline-block margin-bottom-15 text-justified position-relative print-hide' },
                  _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.largeTextDisclosure) } })
                ),
                !(0, _ramda.isNil)(this.props.disclosure) && _collection_utility.CollectionUtility.map(this.props.disclosure, function (disclosure, index) {
                  return _react2.default.createElement('div', { className: 'margin-bottom-15 text-justified print-hide', 'data-testid': "pdpCardPerformance_disclosure_" + index, key: index,
                    dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosure) } });
                })
              )
            )
          )
        )
      );
    }
  }]);

  return PerformanceCard;
}(_react2.default.Component);

exports.default = PerformanceCard;